

// Drop this into your React Router routes:
//
//   import DesignerPage from "./pages/DesignerPage";
//   <Route path="/designer" element={<DesignerPage />} />

import ThreadCraft from "../components/TShirtDesigner";

export default function DesignerPage() {
  return <ThreadCraft />;
}
